import { PaymentsFeatureFlags } from '@frontend/payments-hooks';
import { useChargesEnabledLocations } from '@frontend/person-invoice-create';
import { useAppFlagStore } from '@frontend/shared';
import { ButtonProps, useModalControl, useTooltip } from '@frontend/design-system';

export type UsePaymentsModalButtonOptions = { locationIds?: string[]; personId?: string };
export type UsePaymentsModalButtonReturnType = ReturnType<typeof usePaymentsModalButton>;
const defaultObj = {};

export const usePaymentsModalButton = ({ locationIds, personId }: UsePaymentsModalButtonOptions = {}) => {
  const { chargesEnabledLocations, disabledMessage, getDisabledMessage } = useChargesEnabledLocations({
    locationIds,
    personId,
  });
  const disabled = !!disabledMessage;

  const { getFeatureFlagValue } = useAppFlagStore();

  const { modalProps, triggerProps: modalTriggerProps, openModal, closeModal } = useModalControl();
  const { Tooltip, tooltipProps, triggerProps: errorTooltipTriggerProps } = useTooltip();

  const tooltip = <>{disabledMessage && <Tooltip {...tooltipProps}>{disabledMessage}</Tooltip>}</>;
  const tooltipTriggerProps = disabled ? errorTooltipTriggerProps : defaultObj;

  const handleClick = () => {
    modalTriggerProps.onClick();
  };

  const showMultiProcessorCollect = getFeatureFlagValue({
    flagName: PaymentsFeatureFlags.UseMultiProcessorCollect,
    locationIds: chargesEnabledLocations,
  });

  return {
    tooltipTriggerProps,
    openModal,
    closeModal,
    hidePaymentRequestModal: disabled,
    disabled,
    disabledMessage,
    modalProps,
    showMultiProcessorCollect,
    Tooltip: tooltip,
    triggerProps: {
      disabled,
      ...modalTriggerProps,
      ...tooltipTriggerProps,
      onClick: handleClick,
    } satisfies ButtonProps,
    paymentRequestModalProps: {
      ...modalProps,
      Tooltip: tooltip,
      showMultiProcessorCollect,
    },
    disabledButtonProps: {
      disabled,
      hoverLabel: disabledMessage,
      showLabelWhenDisabled: disabled,
    } satisfies ButtonProps,
    getDisabledMessage,
  };
};
